import { ServerTreatmentPlanStep, TimeSpecificityType } from '../../api/types/treatmentPlanStep';

export const createDefaultStep = (stepNumber?: number): ServerTreatmentPlanStep => ({
  id: Math.floor(Math.random() * 9000000000) + 1000000000,
  title: '',
  description: '',
  start_date: undefined,
  end_date: undefined,
  audio: null,
  media: null,
  note: '',
  folder: null,
  tags: [],
  flag_if_missed: false,
  time_specificity: undefined,
  relative_to_step: null,
  relative_to_date: null,
  offset_amount: null,
  offset_units: null,
  step_num: stepNumber || 1,
  is_temporary: true,
});
